import {
  GUEST_HISTORY_RESET,
  GUEST_HISTORY_SEARCH_FAILURE,
  GUEST_HISTORY_SEARCH_REQUEST,
  GUEST_HISTORY_SEARCH_SUCCESS,
} from "constants/ActionTypes"
import {
  GuestHistoryActions,
  GuestHistoryPaging,
  GuestHistorySearchFilters,
  GuestHistorySearchRequestPayload,
  GuestHistorySearchSuccessPayload,
} from "appRedux/actions/guestHistory"

export interface GuestHistoryState {
  loading: boolean
  error: string | null
  items: GuestHistorySearchSuccessPayload["items"]
  paging: GuestHistoryPaging
  lastRequest: GuestHistorySearchRequestPayload
}

const DEFAULT_PAGING: GuestHistoryPaging = {
  current: 1,
  limit: 20,
  total_rows: 0,
  row_count: 0,
  sort_field: undefined,
  sort_order: undefined,
}

const INITIAL_REQUEST: GuestHistorySearchRequestPayload = {
  filters: {},
  paging: {
    page: 1,
    limit: 20,
  },
}

const INITIAL_STATE: GuestHistoryState = {
  loading: false,
  error: null,
  items: [],
  paging: DEFAULT_PAGING,
  lastRequest: INITIAL_REQUEST,
}

const mergeFilters = (
  current: GuestHistorySearchFilters | undefined,
  incoming: GuestHistorySearchFilters | undefined,
  replace?: boolean
): GuestHistorySearchFilters | undefined => {
  if (replace) {
    return incoming ? { ...incoming } : {}
  }
  return { ...(current || {}), ...(incoming || {}) }
}

export default function guestHistoryReducer(
  state: GuestHistoryState = INITIAL_STATE,
  action: GuestHistoryActions
): GuestHistoryState {
  switch (action.type) {
    case GUEST_HISTORY_SEARCH_REQUEST: {
      const nextFilters = mergeFilters(
        state.lastRequest.filters,
        action.payload.filters,
        action.payload.replaceFilters
      )
      const nextPaging = {
        ...(state.lastRequest.paging || {}),
        ...(action.payload.paging || {}),
      }

      return {
        ...state,
        loading: true,
        error: null,
        lastRequest: {
          filters: nextFilters,
          paging: nextPaging,
          replaceFilters: action.payload.replaceFilters,
        },
      }
    }
    case GUEST_HISTORY_SEARCH_SUCCESS: {
      const { paging, items, request } = action.payload
      return {
        ...state,
        loading: false,
        error: null,
        items,
        paging,
        lastRequest: request || state.lastRequest,
      }
    }
    case GUEST_HISTORY_SEARCH_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }
    }
    case GUEST_HISTORY_RESET:
      return INITIAL_STATE
    default:
      return state
  }
}
